module.exports = __webpack_public_path__ + "img/api_08.28a1f10a.svg";